// extracted by mini-css-extract-plugin
export var img = "HeroWrapper-module--img--JLWXI";
export var large = "HeroWrapper-module--large--Ml6Sd";
export var root = "HeroWrapper-module--root--nFvhE";
export var wrapper = "HeroWrapper-module--wrapper--gLNC+";